import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule, } from '@spartacus/core';
import { CmsPageGuard, DatePickerModule, ListNavigationModule, PageLayoutComponent, SpinnerModule } from '@spartacus/storefront';
import { CustomDatePickerModule } from '../../../../../../custom/forms/date-picker/custom-date-picker.module';
import { CustomIconsModule } from '../../../../../../custom/icons/custom-icons.module';
import { CustomUserOrderEffect } from '../../../../core/user/store/effects/custom-user-order.effect';
import {
  reducerOrderStatusListProvider,
  reducerOrderStatusListToken,
} from '../../../../core/user/store/reducers/custom-user-order.reducer';
import { USER_ORDER_STATUS_FEATURE } from '../../../../core/user/store/selectors/custom-user-order.selector';
import { CustomOrderDetailsModule } from '../custom-order-details';
import { CustomOrderHistoryComponent } from './custom-order-history.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'orders' },
      },
    ]),
    RouterModule,
    FormsModule,
    NgSelectModule,
    ListNavigationModule,
    UrlModule,
    I18nModule,
    CustomIconsModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        AccountOrderHistoryComponent: {
          component: CustomOrderHistoryComponent,
          guards: [AuthGuard],
        },
      },
    }),
    CustomDatePickerModule,
    SpinnerModule,
    CustomOrderDetailsModule,
    DatePickerModule,
    ReactiveFormsModule,
    StoreModule.forFeature(USER_ORDER_STATUS_FEATURE, reducerOrderStatusListToken),
    EffectsModule.forFeature([CustomUserOrderEffect]),
  ],
  providers: [
    reducerOrderStatusListProvider
  ],
  declarations: [CustomOrderHistoryComponent],
  exports: [CustomOrderHistoryComponent]
})
export class CustomOrderHistoryModule {}
